import Button from "@mui/material/Button";

export const CustomButton = ({ children, ...props }) => {
  return (
    <Button
      {...props}
      sx={{
        textTransform: "none",
        backgroundColor: "#e4e4e4",
        borderColor: "#e4e4e4 !important",
        color: "#696969",
        fontWeight: "bold",
        "&:disabled": {
          backgroundColor: "whitesmoke",
          borderColor: "whitesmoke !important",
          color: "#d3d3d3",
        },
        "&:hover": {
          backgroundColor: "#bfbebeff",
        },
        ...props.sx,
      }}
    >
      {children}
    </Button>
  );
};
